import type { GQL } from "@binale-tech/shared";
import type { DmsType } from "@domain/models/dms";

export interface ITableDocument extends GQL.IDocument {
    isFocused?: boolean;
}

export interface IInitColumnsType extends Record<keyof typeof DmsType, string> {
    all_documents: string;
}

// export type TTableCols = Record<keyof ITableColumns, boolean>;
